module.exports = __webpack_public_path__ + "img/portrait-066.03e0c7f2.jpg";